// Recovered compiled webpack factory 16378. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      getFlightDataPartsFromPath: function () {
        return a;
      },
      getNextFlightSegmentPath: function () {
        return o;
      },
      normalizeFlightData: function () {
        return i;
      },
      prepareFlightRouterStateForRequest: function () {
        return s;
      },
    }));
  let n = r(65360);
  function a(e) {
    var t;
    let [r, n, a, o] = e.slice(-4),
      i = e.slice(0, -4);
    return {
      pathToSegment: i.slice(0, -1),
      segmentPath: i,
      segment: null != (t = i[i.length - 1]) ? t : "",
      tree: r,
      seedData: n,
      head: a,
      isHeadPartial: o,
      isRootRender: 4 === e.length,
    };
  }
  function o(e) {
    return e.slice(2);
  }
  function i(e) {
    return "string" == typeof e ? e : e.map((e) => a(e));
  }
  function s(e, t) {
    return t
      ? encodeURIComponent(JSON.stringify(e))
      : encodeURIComponent(
          JSON.stringify(
            (function e(t) {
              var r, a;
              let [o, i, s, l, u, c] = t,
                f =
                  "string" == typeof (r = o) && r.startsWith(n.PAGE_SEGMENT_KEY + "?")
                    ? n.PAGE_SEGMENT_KEY
                    : r,
                d = {};
              for (let [t, r] of Object.entries(i)) d[t] = e(r);
              let p = [f, d, null, (a = l) && "refresh" !== a ? l : null];
              return (void 0 !== u && (p[4] = u), void 0 !== c && (p[5] = c), p);
            })(e),
          ),
        );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
